import React, { FC } from 'react';

import { EvFlexRow, EvIcon, EvTooltip, InfoIcon } from '@evinced-private/ui-common';

import { DASHBOARD_COLUMN_TOOLTIP_ID } from '../ValuesTable.constants';
import { VALUES_TABLE_LABELS } from '../ValuesTable.labels';

export const DashboardColumnHeader: FC = () => (
	<EvFlexRow gap="SMALL" align="CENTER">
		{VALUES_TABLE_LABELS.COLUMN_DASHBOARD_VISIBILITY}
		<EvFlexRow
			as="span"
			gap="NONE"
			align="CENTER"
			ariaLabel={VALUES_TABLE_LABELS.COLUMN_DASHBOARD_VISIBILITY_TOOLTIP}
			data-tooltip-id={DASHBOARD_COLUMN_TOOLTIP_ID}
			data-tooltip-content={VALUES_TABLE_LABELS.COLUMN_DASHBOARD_VISIBILITY_TOOLTIP}
		>
			<EvIcon icon={InfoIcon} small />
		</EvFlexRow>
		<EvTooltip id={DASHBOARD_COLUMN_TOOLTIP_ID} place="top" type="info" />
	</EvFlexRow>
);
